import { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, TermFilter, FilterOptions, GradeOptions } from "../../../../../../_helpers/Helpers";
import { useUnregisteredStudentsUIContext } from "../UnregisteredStudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, tcKimlikNo, name, surname, grade, school, parentName } = values;
  const newQueryParams = { ...queryParams };
  const filter = { tcKimlikNo, name, surname, grade, school, parentName };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function UnregisteredStudentsFilter() {
  // Unregistered Students UI Context
  const unregisteredStudentsUIContext = useUnregisteredStudentsUIContext();
  const unregisteredStudentsUIProps = useMemo(() => {
    return {
      queryParams: unregisteredStudentsUIContext.queryParams,
      setQueryParams: unregisteredStudentsUIContext.setQueryParams
    };
  }, [unregisteredStudentsUIContext]);
  
  const { currentActiveTerm } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm
    }),
    shallowEqual
  );
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(unregisteredStudentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, unregisteredStudentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      unregisteredStudentsUIProps.setQueryParams(newQueryParams);
    }
  };

 const gradeOptions = FilterOptions.concat(GradeOptions)

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        tcKimlikNo: "",
        name: "",
        surname: "",
        school: "",
        parentName: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıfı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıfı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="school"
                placeholder="Okulu"
                onBlur={handleBlur}
                value={values.school}
                onChange={(e) => {
                  setFieldValue("school", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Okulu</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="parentName"
                placeholder="Veli Adı Soyadı"
                onBlur={handleBlur}
                value={values.parentName}
                onChange={(e) => {
                  setFieldValue("parentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Veli Adı Soyadı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}